const en = {
	'快跟我一起来<br />SuperChinese学中文吧!': 'I am learning Chinese<br />on SuperChinese. Join me!',
	'零基础任性学': 'Learn from scratch',
	'听说读写全面提升': 'Improve Chinese listening, reading, writing and speaking',
	'趣味对话': 'Fun Conversation',
	'100+日常对话等你来': '100+ everyday conversations are here for you to learn',
	'智能AI': 'AI-powered engine',
	'个性化学习推荐，由浅入深系统学': 'Personalized and systematic learning experiences to make your learning counts',
	'趣味对话等你来': 'Fun conversations are here for you to learn',
	'立即打开': 'Open',
	'我在SuperChinese<br />已累计学习{day}天': 'I am using SuperChinese<br />for <span>{day}</span> days',
	'我在SuperChinese<br />已连续学习{day}天': 'I am using SuperChinese<br />for <span>{day}</span> days',
	'学习生词': 'Vocab<br />learned',
	'学习语法': 'Grammar<br />learned',
	'口语练习': 'Speak fluent Chinese for',
	'{n}个': '<span>{n}</span>',
	'{n}次': '<span>{n}</span>times',
	'点击右上角的按钮,选择在浏览器中打开': 'Click here {...} in the right top corner, Choose a browser to open',
	'邀请码': 'Invitation code',
	'用邀请码注册，参与抽大奖': 'Invite new users to register and fill in the invitation code to participate in the lottery.',
}
export default en;